@file:OptIn(InternalResourceApi::class)

package evoshift.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/evoshift.composeapp.generated.resources/"

@delegate:ResourceContentHash(1_599_947_178)
public val Res.string.absence_status_approved: StringResource by lazy {
      StringResource("string:absence_status_approved", "absence_status_approved", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 7775, 47),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 10731, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4226, 43),
      ))
    }

@delegate:ResourceContentHash(170_705_757)
public val Res.string.absence_status_pending: StringResource by lazy {
      StringResource("string:absence_status_pending", "absence_status_pending", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 7823, 42),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 10787, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4270, 42),
      ))
    }

@delegate:ResourceContentHash(1_606_424_017)
public val Res.string.absence_status_rejected: StringResource by lazy {
      StringResource("string:absence_status_rejected", "absence_status_rejected", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 7866, 43),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 10846, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4313, 43),
      ))
    }

@delegate:ResourceContentHash(-1_255_686_256)
public val Res.string.absence_type_blood_donation: StringResource by lazy {
      StringResource("string:absence_type_blood_donation", "absence_type_blood_donation", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 7910, 51),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 10902, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4357, 55),
      ))
    }

@delegate:ResourceContentHash(-846_346_378)
public val Res.string.absence_type_care_allowance: StringResource by lazy {
      StringResource("string:absence_type_care_allowance", "absence_type_care_allowance", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 7962, 71),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 10978, 91),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4413, 63),
      ))
    }

@delegate:ResourceContentHash(-1_920_403_149)
public val Res.string.absence_type_carer_leave: StringResource by lazy {
      StringResource("string:absence_type_carer_leave", "absence_type_carer_leave", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 8034, 56),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 11070, 112),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4477, 52),
      ))
    }

@delegate:ResourceContentHash(1_585_099_170)
public val Res.string.absence_type_childcare: StringResource by lazy {
      StringResource("string:absence_type_childcare", "absence_type_childcare", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 8152, 70),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 11336, 98),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4611, 66),
      ))
    }

@delegate:ResourceContentHash(-1_688_103_640)
public val Res.string.absence_type_childcare_leave: StringResource by lazy {
      StringResource("string:absence_type_childcare_leave", "absence_type_childcare_leave", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 8091, 60),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 11183, 152),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4530, 80),
      ))
    }

@delegate:ResourceContentHash(1_191_482_693)
public val Res.string.absence_type_force_majeure: StringResource by lazy {
      StringResource("string:absence_type_force_majeure", "absence_type_force_majeure", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 8223, 82),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 11435, 106),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4678, 62),
      ))
    }

@delegate:ResourceContentHash(-888_324_644)
public val Res.string.absence_type_maternity: StringResource by lazy {
      StringResource("string:absence_type_maternity", "absence_type_maternity", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 8306, 58),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 11542, 94),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4741, 50),
      ))
    }

@delegate:ResourceContentHash(-750_269_483)
public val Res.string.absence_type_occasional_leave: StringResource by lazy {
      StringResource("string:absence_type_occasional_leave", "absence_type_occasional_leave", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 8365, 69),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 11637, 137),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4792, 89),
      ))
    }

@delegate:ResourceContentHash(-145_077_745)
public val Res.string.absence_type_on_demand: StringResource by lazy {
      StringResource("string:absence_type_on_demand", "absence_type_on_demand", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 8435, 54),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 11775, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4882, 50),
      ))
    }

@delegate:ResourceContentHash(-1_728_703_846)
public val Res.string.absence_type_parental: StringResource by lazy {
      StringResource("string:absence_type_parental", "absence_type_parental", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 8490, 53),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 11854, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4933, 49),
      ))
    }

@delegate:ResourceContentHash(1_487_098_829)
public val Res.string.absence_type_paternity: StringResource by lazy {
      StringResource("string:absence_type_paternity", "absence_type_paternity", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 8544, 50),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 11940, 82),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4983, 50),
      ))
    }

@delegate:ResourceContentHash(1_128_819_175)
public val Res.string.absence_type_quarantine: StringResource by lazy {
      StringResource("string:absence_type_quarantine", "absence_type_quarantine", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 8595, 63),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 12023, 87),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5034, 63),
      ))
    }

@delegate:ResourceContentHash(-1_840_823_299)
public val Res.string.absence_type_sick_leave: StringResource by lazy {
      StringResource("string:absence_type_sick_leave", "absence_type_sick_leave", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 8659, 59),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 12111, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5098, 47),
      ))
    }

@delegate:ResourceContentHash(-206_045_128)
public val Res.string.absence_type_time_off_in_lieu: StringResource by lazy {
      StringResource("string:absence_type_time_off_in_lieu", "absence_type_time_off_in_lieu", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 8719, 69),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 12171, 113),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5146, 65),
      ))
    }

@delegate:ResourceContentHash(-1_336_881_250)
public val Res.string.absence_type_unpaid_leave: StringResource by lazy {
      StringResource("string:absence_type_unpaid_leave", "absence_type_unpaid_leave", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 8789, 57),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 12285, 137),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5212, 49),
      ))
    }

@delegate:ResourceContentHash(2_043_441_945)
public val Res.string.absence_type_vacation: StringResource by lazy {
      StringResource("string:absence_type_vacation", "absence_type_vacation", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 8847, 53),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 12423, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5262, 41),
      ))
    }

@delegate:ResourceContentHash(-293_261_309)
public val Res.string.absences_action_approve: StringResource by lazy {
      StringResource("string:absences_action_approve", "absences_action_approve", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 8901, 47),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 12497, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5304, 43),
      ))
    }

@delegate:ResourceContentHash(-635_298_906)
public val Res.string.absences_action_cancel: StringResource by lazy {
      StringResource("string:absences_action_cancel", "absences_action_cancel", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 8949, 50),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 12553, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5348, 50),
      ))
    }

@delegate:ResourceContentHash(1_891_771_094)
public val Res.string.absences_action_reject: StringResource by lazy {
      StringResource("string:absences_action_reject", "absences_action_reject", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 9000, 42),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 12624, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5399, 38),
      ))
    }

@delegate:ResourceContentHash(1_724_942_831)
public val Res.string.absences_action_submit: StringResource by lazy {
      StringResource("string:absences_action_submit", "absences_action_submit", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 9043, 50),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 12679, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5438, 50),
      ))
    }

@delegate:ResourceContentHash(-1_004_256_809)
public val Res.string.absences_active_requests: StringResource by lazy {
      StringResource("string:absences_active_requests", "absences_active_requests", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 9094, 52),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 12742, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5489, 52),
      ))
    }

@delegate:ResourceContentHash(508_186_035)
public val Res.string.absences_attachment: StringResource by lazy {
      StringResource("string:absences_attachment", "absences_attachment", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 9147, 43),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 12811, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5542, 43),
      ))
    }

@delegate:ResourceContentHash(1_843_772_953)
public val Res.string.absences_confirm_remove: StringResource by lazy {
      StringResource("string:absences_confirm_remove", "absences_confirm_remove", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 9191, 79),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 12863, 91),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5586, 91),
      ))
    }

@delegate:ResourceContentHash(1_084_547_578)
public val Res.string.absences_empty: StringResource by lazy {
      StringResource("string:absences_empty", "absences_empty", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 9271, 50),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 12955, 86),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5678, 46),
      ))
    }

@delegate:ResourceContentHash(821_151_394)
public val Res.string.absences_end_date: StringResource by lazy {
      StringResource("string:absences_end_date", "absences_end_date", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 9322, 45),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 13042, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5725, 37),
      ))
    }

@delegate:ResourceContentHash(-1_677_461_850)
public val Res.string.absences_history: StringResource by lazy {
      StringResource("string:absences_history", "absences_history", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 9368, 36),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 13108, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5763, 36),
      ))
    }

@delegate:ResourceContentHash(-788_495_772)
public val Res.string.absences_modify: StringResource by lazy {
      StringResource("string:absences_modify", "absences_modify", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 9405, 31),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 13153, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5800, 31),
      ))
    }

@delegate:ResourceContentHash(1_718_954_692)
public val Res.string.absences_period: StringResource by lazy {
      StringResource("string:absences_period", "absences_period", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 9437, 31),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 13197, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5832, 31),
      ))
    }

@delegate:ResourceContentHash(-1_716_912_658)
public val Res.string.absences_reason: StringResource by lazy {
      StringResource("string:absences_reason", "absences_reason", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 9698, 31),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 13606, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6077, 31),
      ))
    }

@delegate:ResourceContentHash(1_906_186_230)
public val Res.string.absences_reason_hint: StringResource by lazy {
      StringResource("string:absences_reason_hint", "absences_reason_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 9469, 60),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 13237, 92),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5864, 48),
      ))
    }

@delegate:ResourceContentHash(1_022_464_328)
public val Res.string.absences_reason_privacy: StringResource by lazy {
      StringResource("string:absences_reason_privacy", "absences_reason_privacy", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 9530, 167),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 13330, 275),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5913, 163),
      ))
    }

@delegate:ResourceContentHash(-849_738_178)
public val Res.string.absences_rejection_reason: StringResource by lazy {
      StringResource("string:absences_rejection_reason", "absences_rejection_reason", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 9730, 65),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 13650, 89),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6109, 69),
      ))
    }

@delegate:ResourceContentHash(1_704_073_326)
public val Res.string.absences_remove: StringResource by lazy {
      StringResource("string:absences_remove", "absences_remove", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 9796, 31),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 13740, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6179, 31),
      ))
    }

@delegate:ResourceContentHash(-1_090_706_296)
public val Res.string.absences_request_new: StringResource by lazy {
      StringResource("string:absences_request_new", "absences_request_new", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 9828, 44),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 13788, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6211, 44),
      ))
    }

@delegate:ResourceContentHash(525_612_990)
public val Res.string.absences_sick_pay_full: StringResource by lazy {
      StringResource("string:absences_sick_pay_full", "absences_sick_pay_full", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 9873, 114),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 13845, 162),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6256, 90),
      ))
    }

@delegate:ResourceContentHash(265_369_679)
public val Res.string.absences_start_date: StringResource by lazy {
      StringResource("string:absences_start_date", "absences_start_date", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 9988, 51),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 14008, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6347, 43),
      ))
    }

@delegate:ResourceContentHash(-1_348_582_570)
public val Res.string.absences_status: StringResource by lazy {
      StringResource("string:absences_status", "absences_status", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 10040, 31),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 14068, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6391, 31),
      ))
    }

@delegate:ResourceContentHash(13_015_120)
public val Res.string.absences_title: StringResource by lazy {
      StringResource("string:absences_title", "absences_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 10072, 42),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 14108, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6423, 34),
      ))
    }

@delegate:ResourceContentHash(81_873_694)
public val Res.string.absences_type_label: StringResource by lazy {
      StringResource("string:absences_type_label", "absences_type_label", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 10115, 47),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 14163, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6458, 43),
      ))
    }

@delegate:ResourceContentHash(273_089_631)
public val Res.string.access_above_own: StringResource by lazy {
      StringResource("string:access_above_own", "access_above_own", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 10163, 88),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 14215, 124),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6502, 92),
      ))
    }

@delegate:ResourceContentHash(1_303_334_340)
public val Res.string.access_blocked_group: StringResource by lazy {
      StringResource("string:access_blocked_group", "access_blocked_group", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 10252, 120),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 14340, 188),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6595, 132),
      ))
    }

@delegate:ResourceContentHash(1_975_847_622)
public val Res.string.access_blocked_owner: StringResource by lazy {
      StringResource("string:access_blocked_owner", "access_blocked_owner", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 10373, 88),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 14529, 108),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6728, 80),
      ))
    }

@delegate:ResourceContentHash(-1_290_017_692)
public val Res.string.access_blocked_self: StringResource by lazy {
      StringResource("string:access_blocked_self", "access_blocked_self", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 10462, 87),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 14638, 127),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6809, 75),
      ))
    }

@delegate:ResourceContentHash(1_902_788_212)
public val Res.string.access_error_above_own: StringResource by lazy {
      StringResource("string:access_error_above_own", "access_error_above_own", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 10550, 102),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 14766, 138),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6885, 98),
      ))
    }

@delegate:ResourceContentHash(-924_138_077)
public val Res.string.access_error_name_taken: StringResource by lazy {
      StringResource("string:access_error_name_taken", "access_error_name_taken", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 10653, 75),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 14905, 107),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6984, 83),
      ))
    }

@delegate:ResourceContentHash(1_330_080_281)
public val Res.string.access_error_not_allowed: StringResource by lazy {
      StringResource("string:access_error_not_allowed", "access_error_not_allowed", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 10729, 100),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 15013, 148),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7068, 84),
      ))
    }

@delegate:ResourceContentHash(-559_810_706)
public val Res.string.access_error_not_found: StringResource by lazy {
      StringResource("string:access_error_not_found", "access_error_not_found", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 10830, 78),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 15162, 114),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7153, 82),
      ))
    }

@delegate:ResourceContentHash(1_657_632_811)
public val Res.string.access_error_plan: StringResource by lazy {
      StringResource("string:access_error_plan", "access_error_plan", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 10909, 105),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 15277, 165),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7236, 101),
      ))
    }

@delegate:ResourceContentHash(-620_047)
public val Res.string.access_error_role_in_use: StringResource by lazy {
      StringResource("string:access_error_role_in_use", "access_error_role_in_use", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 11015, 92),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 15443, 140),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7338, 104),
      ))
    }

@delegate:ResourceContentHash(343_896_959)
public val Res.string.access_error_too_many_roles: StringResource by lazy {
      StringResource("string:access_error_too_many_roles", "access_error_too_many_roles", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 11108, 107),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 15584, 163),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7443, 103),
      ))
    }

@delegate:ResourceContentHash(-2_077_645_431)
public val Res.string.access_intro: StringResource by lazy {
      StringResource("string:access_intro", "access_intro", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 11216, 168),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 15748, 272),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7547, 176),
      ))
    }

@delegate:ResourceContentHash(-539_270_258)
public val Res.string.access_level_edit: StringResource by lazy {
      StringResource("string:access_level_edit", "access_level_edit", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 11385, 33),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 16021, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7724, 33),
      ))
    }

@delegate:ResourceContentHash(-1_499_092_863)
public val Res.string.access_level_none: StringResource by lazy {
      StringResource("string:access_level_none", "access_level_none", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 11419, 33),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 16079, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7758, 33),
      ))
    }

@delegate:ResourceContentHash(2_027_202_399)
public val Res.string.access_level_view: StringResource by lazy {
      StringResource("string:access_level_view", "access_level_view", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 11453, 37),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 16121, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7792, 33),
      ))
    }

@delegate:ResourceContentHash(2_098_240_605)
public val Res.string.access_modified: StringResource by lazy {
      StringResource("string:access_modified", "access_modified", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 11491, 35),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 16171, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7826, 35),
      ))
    }

@delegate:ResourceContentHash(1_975_624_775)
public val Res.string.access_older_apps: StringResource by lazy {
      StringResource("string:access_older_apps", "access_older_apps", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 11527, 105),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 16215, 177),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7862, 105),
      ))
    }

@delegate:ResourceContentHash(-1_526_166_986)
public val Res.string.access_open: StringResource by lazy {
      StringResource("string:access_open", "access_open", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 11633, 51),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 16393, 79),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7968, 43),
      ))
    }

@delegate:ResourceContentHash(-814_733_452)
public val Res.string.access_reset_feature: StringResource by lazy {
      StringResource("string:access_reset_feature", "access_reset_feature", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 11685, 60),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 16473, 84),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8012, 60),
      ))
    }

@delegate:ResourceContentHash(-1_422_476_478)
public val Res.string.access_reset_to_role: StringResource by lazy {
      StringResource("string:access_reset_to_role", "access_reset_to_role", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 11746, 64),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 16558, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8073, 64),
      ))
    }

@delegate:ResourceContentHash(-1_641_285_238)
public val Res.string.access_role: StringResource by lazy {
      StringResource("string:access_role", "access_role", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 11811, 27),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 16639, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8138, 27),
      ))
    }

@delegate:ResourceContentHash(-956_634_296)
public val Res.string.access_saved: StringResource by lazy {
      StringResource("string:access_saved", "access_saved", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 11839, 48),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 16671, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8166, 36),
      ))
    }

@delegate:ResourceContentHash(-162_512_029)
public val Res.string.access_summary: StringResource by lazy {
      StringResource("string:access_summary", "access_summary", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 11888, 50),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 16752, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8203, 50),
      ))
    }

@delegate:ResourceContentHash(-41_063_916)
public val Res.string.access_title: StringResource by lazy {
      StringResource("string:access_title", "access_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 11939, 36),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 16811, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8254, 28),
      ))
    }

@delegate:ResourceContentHash(373_510_099)
public val Res.string.accident_rate_invalid: StringResource by lazy {
      StringResource("string:accident_rate_invalid", "accident_rate_invalid", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 11976, 61),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 16868, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8283, 69),
      ))
    }

@delegate:ResourceContentHash(-17_722_174)
public val Res.string.accountant_download: StringResource by lazy {
      StringResource("string:accountant_download", "accountant_download", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 12038, 39),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 16954, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8353, 39),
      ))
    }

@delegate:ResourceContentHash(446_474_650)
public val Res.string.accountant_email_label: StringResource by lazy {
      StringResource("string:accountant_email_label", "accountant_email_label", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 12078, 82),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 17014, 106),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8393, 70),
      ))
    }

@delegate:ResourceContentHash(291_453_368)
public val Res.string.accountant_export: StringResource by lazy {
      StringResource("string:accountant_export", "accountant_export", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 12465, 49),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 17661, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8800, 49),
      ))
    }

@delegate:ResourceContentHash(-1_183_368_175)
public val Res.string.accountant_export_intro: StringResource by lazy {
      StringResource("string:accountant_export_intro", "accountant_export_intro", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 12161, 231),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 17121, 439),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8464, 259),
      ))
    }

@delegate:ResourceContentHash(1_538_797_594)
public val Res.string.accountant_export_title: StringResource by lazy {
      StringResource("string:accountant_export_title", "accountant_export_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 12393, 71),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 17561, 99),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8724, 75),
      ))
    }

@delegate:ResourceContentHash(-980_459_779)
public val Res.string.accountant_format_attendance_pdf: StringResource by lazy {
      StringResource("string:accountant_format_attendance_pdf", "accountant_format_attendance_pdf", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 12625, 72),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 17869, 96),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8948, 68),
      ))
    }

@delegate:ResourceContentHash(969_551_031)
public val Res.string.accountant_format_attendance_pdf_text: StringResource by lazy {
      StringResource("string:accountant_format_attendance_pdf_text", "accountant_format_attendance_pdf_text", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 12515, 109),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 17723, 145),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8850, 97),
      ))
    }

@delegate:ResourceContentHash(-647_986_772)
public val Res.string.accountant_format_enova: StringResource by lazy {
      StringResource("string:accountant_format_enova", "accountant_format_enova", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 12827, 59),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 18119, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9118, 59),
      ))
    }

@delegate:ResourceContentHash(1_479_439_506)
public val Res.string.accountant_format_enova_text: StringResource by lazy {
      StringResource("string:accountant_format_enova_text", "accountant_format_enova_text", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 12698, 128),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 17966, 152),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9017, 100),
      ))
    }

@delegate:ResourceContentHash(350_694_382)
public val Res.string.accountant_format_generic_csv: StringResource by lazy {
      StringResource("string:accountant_format_generic_csv", "accountant_format_generic_csv", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 13014, 61),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 18390, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9289, 69),
      ))
    }

@delegate:ResourceContentHash(-954_021_625)
public val Res.string.accountant_format_generic_csv_text: StringResource by lazy {
      StringResource("string:accountant_format_generic_csv_text", "accountant_format_generic_csv_text", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 12887, 126),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 18187, 202),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9178, 110),
      ))
    }

@delegate:ResourceContentHash(706_562_669)
public val Res.string.accountant_format_optima: StringResource by lazy {
      StringResource("string:accountant_format_optima", "accountant_format_optima", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 13230, 76),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 18642, 84),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9461, 76),
      ))
    }

@delegate:ResourceContentHash(-1_479_803_938)
public val Res.string.accountant_format_optima_text: StringResource by lazy {
      StringResource("string:accountant_format_optima_text", "accountant_format_optima_text", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 13076, 153),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 18468, 173),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9359, 101),
      ))
    }

@delegate:ResourceContentHash(1_951_854_163)
public val Res.string.accountant_format_package: StringResource by lazy {
      StringResource("string:accountant_format_package", "accountant_format_package", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 13414, 53),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 18874, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9661, 57),
      ))
    }

@delegate:ResourceContentHash(-356_905_897)
public val Res.string.accountant_format_package_text: StringResource by lazy {
      StringResource("string:accountant_format_package_text", "accountant_format_package_text", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 13307, 106),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 18727, 146),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9538, 122),
      ))
    }

@delegate:ResourceContentHash(1_316_577_669)
public val Res.string.accountant_format_symfonia: StringResource by lazy {
      StringResource("string:accountant_format_symfonia", "accountant_format_symfonia", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 13612, 82),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 19140, 90),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9831, 82),
      ))
    }

@delegate:ResourceContentHash(-42_152_847)
public val Res.string.accountant_format_symfonia_text: StringResource by lazy {
      StringResource("string:accountant_format_symfonia_text", "accountant_format_symfonia_text", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 13468, 143),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 18940, 199),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9719, 111),
      ))
    }

@delegate:ResourceContentHash(453_337_214)
public val Res.string.accountant_format_time_record_pdf: StringResource by lazy {
      StringResource("string:accountant_format_time_record_pdf", "accountant_format_time_record_pdf", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 13858, 77),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 19486, 97),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10061, 77),
      ))
    }

@delegate:ResourceContentHash(670_102_397)
public val Res.string.accountant_format_time_record_pdf_text: StringResource by lazy {
      StringResource("string:accountant_format_time_record_pdf_text", "accountant_format_time_record_pdf_text", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 13695, 162),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 19231, 254),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9914, 146),
      ))
    }

@delegate:ResourceContentHash(747_048_209)
public val Res.string.accountant_format_time_record_xlsx: StringResource by lazy {
      StringResource("string:accountant_format_time_record_xlsx", "accountant_format_time_record_xlsx", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 14068, 82),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 19768, 102),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10267, 78),
      ))
    }

@delegate:ResourceContentHash(-295_957_848)
public val Res.string.accountant_format_time_record_xlsx_text: StringResource by lazy {
      StringResource("string:accountant_format_time_record_xlsx_text", "accountant_format_time_record_xlsx_text", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 13936, 131),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 19584, 183),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10139, 127),
      ))
    }

@delegate:ResourceContentHash(1_106_958_600)
public val Res.string.accountant_mail_not_set_up: StringResource by lazy {
      StringResource("string:accountant_mail_not_set_up", "accountant_mail_not_set_up", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 14151, 146),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 19871, 162),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10346, 114),
      ))
    }

@delegate:ResourceContentHash(-1_386_552_097)
public val Res.string.accountant_mail_too_soon: StringResource by lazy {
      StringResource("string:accountant_mail_too_soon", "accountant_mail_too_soon", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 14298, 104),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 20034, 184),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10461, 100),
      ))
    }

@delegate:ResourceContentHash(1_684_628_710)
public val Res.string.accountant_missing_payroll_ids: StringResource by lazy {
      StringResource("string:accountant_missing_payroll_ids", "accountant_missing_payroll_ids", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 14403, 190),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 20219, 278),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10562, 158),
      ))
    }

@delegate:ResourceContentHash(1_467_947_528)
public val Res.string.accountant_open_file: StringResource by lazy {
      StringResource("string:accountant_open_file", "accountant_open_file", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 14594, 44),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 20498, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10721, 48),
      ))
    }

@delegate:ResourceContentHash(252_640_240)
public val Res.string.accountant_ready: StringResource by lazy {
      StringResource("string:accountant_ready", "accountant_ready", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 14639, 88),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 20563, 108),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10770, 84),
      ))
    }

@delegate:ResourceContentHash(-8_221_293)
public val Res.string.accountant_send: StringResource by lazy {
      StringResource("string:accountant_send", "accountant_send", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 14728, 47),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 20672, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10855, 43),
      ))
    }

@delegate:ResourceContentHash(-1_894_454_309)
public val Res.string.accountant_sent: StringResource by lazy {
      StringResource("string:accountant_sent", "accountant_sent", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 14910, 55),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 20930, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11045, 43),
      ))
    }

@delegate:ResourceContentHash(-1_131_371_764)
public val Res.string.accountant_sent_link_only: StringResource by lazy {
      StringResource("string:accountant_sent_link_only", "accountant_sent_link_only", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 14776, 133),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 20732, 197),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10899, 145),
      ))
    }

@delegate:ResourceContentHash(396_986_894)
public val Res.string.accountant_working: StringResource by lazy {
      StringResource("string:accountant_working", "accountant_working", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 14966, 58),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 20994, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11089, 54),
      ))
    }

@delegate:ResourceContentHash(1_029_991_953)
public val Res.string.actual_work_absence_failed: StringResource by lazy {
      StringResource("string:actual_work_absence_failed", "actual_work_absence_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 15025, 166),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 21057, 242),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11144, 138),
      ))
    }

@delegate:ResourceContentHash(-2_073_599_564)
public val Res.string.actual_work_absence_type: StringResource by lazy {
      StringResource("string:actual_work_absence_type", "actual_work_absence_type", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 15192, 60),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 21300, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11283, 52),
      ))
    }

@delegate:ResourceContentHash(-832_031_615)
public val Res.string.actual_work_action: StringResource by lazy {
      StringResource("string:actual_work_action", "actual_work_action", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 15348, 50),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 21496, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11423, 46),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("absence_status_approved", Res.string.absence_status_approved)
  map.put("absence_status_pending", Res.string.absence_status_pending)
  map.put("absence_status_rejected", Res.string.absence_status_rejected)
  map.put("absence_type_blood_donation", Res.string.absence_type_blood_donation)
  map.put("absence_type_care_allowance", Res.string.absence_type_care_allowance)
  map.put("absence_type_carer_leave", Res.string.absence_type_carer_leave)
  map.put("absence_type_childcare", Res.string.absence_type_childcare)
  map.put("absence_type_childcare_leave", Res.string.absence_type_childcare_leave)
  map.put("absence_type_force_majeure", Res.string.absence_type_force_majeure)
  map.put("absence_type_maternity", Res.string.absence_type_maternity)
  map.put("absence_type_occasional_leave", Res.string.absence_type_occasional_leave)
  map.put("absence_type_on_demand", Res.string.absence_type_on_demand)
  map.put("absence_type_parental", Res.string.absence_type_parental)
  map.put("absence_type_paternity", Res.string.absence_type_paternity)
  map.put("absence_type_quarantine", Res.string.absence_type_quarantine)
  map.put("absence_type_sick_leave", Res.string.absence_type_sick_leave)
  map.put("absence_type_time_off_in_lieu", Res.string.absence_type_time_off_in_lieu)
  map.put("absence_type_unpaid_leave", Res.string.absence_type_unpaid_leave)
  map.put("absence_type_vacation", Res.string.absence_type_vacation)
  map.put("absences_action_approve", Res.string.absences_action_approve)
  map.put("absences_action_cancel", Res.string.absences_action_cancel)
  map.put("absences_action_reject", Res.string.absences_action_reject)
  map.put("absences_action_submit", Res.string.absences_action_submit)
  map.put("absences_active_requests", Res.string.absences_active_requests)
  map.put("absences_attachment", Res.string.absences_attachment)
  map.put("absences_confirm_remove", Res.string.absences_confirm_remove)
  map.put("absences_empty", Res.string.absences_empty)
  map.put("absences_end_date", Res.string.absences_end_date)
  map.put("absences_history", Res.string.absences_history)
  map.put("absences_modify", Res.string.absences_modify)
  map.put("absences_period", Res.string.absences_period)
  map.put("absences_reason", Res.string.absences_reason)
  map.put("absences_reason_hint", Res.string.absences_reason_hint)
  map.put("absences_reason_privacy", Res.string.absences_reason_privacy)
  map.put("absences_rejection_reason", Res.string.absences_rejection_reason)
  map.put("absences_remove", Res.string.absences_remove)
  map.put("absences_request_new", Res.string.absences_request_new)
  map.put("absences_sick_pay_full", Res.string.absences_sick_pay_full)
  map.put("absences_start_date", Res.string.absences_start_date)
  map.put("absences_status", Res.string.absences_status)
  map.put("absences_title", Res.string.absences_title)
  map.put("absences_type_label", Res.string.absences_type_label)
  map.put("access_above_own", Res.string.access_above_own)
  map.put("access_blocked_group", Res.string.access_blocked_group)
  map.put("access_blocked_owner", Res.string.access_blocked_owner)
  map.put("access_blocked_self", Res.string.access_blocked_self)
  map.put("access_error_above_own", Res.string.access_error_above_own)
  map.put("access_error_name_taken", Res.string.access_error_name_taken)
  map.put("access_error_not_allowed", Res.string.access_error_not_allowed)
  map.put("access_error_not_found", Res.string.access_error_not_found)
  map.put("access_error_plan", Res.string.access_error_plan)
  map.put("access_error_role_in_use", Res.string.access_error_role_in_use)
  map.put("access_error_too_many_roles", Res.string.access_error_too_many_roles)
  map.put("access_intro", Res.string.access_intro)
  map.put("access_level_edit", Res.string.access_level_edit)
  map.put("access_level_none", Res.string.access_level_none)
  map.put("access_level_view", Res.string.access_level_view)
  map.put("access_modified", Res.string.access_modified)
  map.put("access_older_apps", Res.string.access_older_apps)
  map.put("access_open", Res.string.access_open)
  map.put("access_reset_feature", Res.string.access_reset_feature)
  map.put("access_reset_to_role", Res.string.access_reset_to_role)
  map.put("access_role", Res.string.access_role)
  map.put("access_saved", Res.string.access_saved)
  map.put("access_summary", Res.string.access_summary)
  map.put("access_title", Res.string.access_title)
  map.put("accident_rate_invalid", Res.string.accident_rate_invalid)
  map.put("accountant_download", Res.string.accountant_download)
  map.put("accountant_email_label", Res.string.accountant_email_label)
  map.put("accountant_export", Res.string.accountant_export)
  map.put("accountant_export_intro", Res.string.accountant_export_intro)
  map.put("accountant_export_title", Res.string.accountant_export_title)
  map.put("accountant_format_attendance_pdf", Res.string.accountant_format_attendance_pdf)
  map.put("accountant_format_attendance_pdf_text", Res.string.accountant_format_attendance_pdf_text)
  map.put("accountant_format_enova", Res.string.accountant_format_enova)
  map.put("accountant_format_enova_text", Res.string.accountant_format_enova_text)
  map.put("accountant_format_generic_csv", Res.string.accountant_format_generic_csv)
  map.put("accountant_format_generic_csv_text", Res.string.accountant_format_generic_csv_text)
  map.put("accountant_format_optima", Res.string.accountant_format_optima)
  map.put("accountant_format_optima_text", Res.string.accountant_format_optima_text)
  map.put("accountant_format_package", Res.string.accountant_format_package)
  map.put("accountant_format_package_text", Res.string.accountant_format_package_text)
  map.put("accountant_format_symfonia", Res.string.accountant_format_symfonia)
  map.put("accountant_format_symfonia_text", Res.string.accountant_format_symfonia_text)
  map.put("accountant_format_time_record_pdf", Res.string.accountant_format_time_record_pdf)
  map.put("accountant_format_time_record_pdf_text", Res.string.accountant_format_time_record_pdf_text)
  map.put("accountant_format_time_record_xlsx", Res.string.accountant_format_time_record_xlsx)
  map.put("accountant_format_time_record_xlsx_text", Res.string.accountant_format_time_record_xlsx_text)
  map.put("accountant_mail_not_set_up", Res.string.accountant_mail_not_set_up)
  map.put("accountant_mail_too_soon", Res.string.accountant_mail_too_soon)
  map.put("accountant_missing_payroll_ids", Res.string.accountant_missing_payroll_ids)
  map.put("accountant_open_file", Res.string.accountant_open_file)
  map.put("accountant_ready", Res.string.accountant_ready)
  map.put("accountant_send", Res.string.accountant_send)
  map.put("accountant_sent", Res.string.accountant_sent)
  map.put("accountant_sent_link_only", Res.string.accountant_sent_link_only)
  map.put("accountant_working", Res.string.accountant_working)
  map.put("actual_work_absence_failed", Res.string.actual_work_absence_failed)
  map.put("actual_work_absence_type", Res.string.actual_work_absence_type)
  map.put("actual_work_action", Res.string.actual_work_action)
}
